<template>
  <div style="text-align: center;">
    <h5>班级查询</h5>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="grade" label="年级"></el-table-column>
      <el-table-column prop="class" label="班级"></el-table-column>
      <el-table-column prop="teacher" label="老师"></el-table-column>
      <el-table-column label="二维码">
        <template #default="scope">
          <img v-if="scope.row.barcode" :src="scope.row.barcode" alt="二维码" style="width: 100px; height: 100px">
          <span v-else style="color:#909399;">无</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260">
        <template #default="scope">
          <el-button size="small" type="primary" @click="openEdit(scope.row)">修改</el-button>
          <el-button size="small" type="warning" @click="openBarcode(scope.row)">更换二维码</el-button>
          <el-button size="small" type="danger" @click="confirmDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 修改班级信息 -->
    <el-dialog v-model="editVisible" title="修改班级信息" width="420px">
      <el-form label-width="70px">
        <el-form-item label="年级">
          <el-input v-model="editForm.grade"></el-input>
        </el-form-item>
        <el-form-item label="班级">
          <el-input v-model="editForm.class"></el-input>
        </el-form-item>
        <el-form-item label="老师">
          <el-input v-model="editForm.teacher"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveEdit">保存</el-button>
      </template>
    </el-dialog>

    <!-- 更换二维码 -->
    <el-dialog v-model="barcodeVisible" :title="barcodeTitle" width="420px">
      <div style="text-align:center;">
        <el-upload
          ref="barcodeUploadRef"
          action=""
          :http-request="noop"
          :before-upload="beforeBarcodeUpload"
          :show-file-list="false"
          accept=".png,.jpg,.jpeg,.gif,.webp"
        >
          <el-button type="primary">选择二维码图片</el-button>
        </el-upload>
        <div v-if="barcodePreview" style="margin-top:16px;">
          <div style="margin-bottom:6px;color:#606266;">预览</div>
          <img :src="barcodePreview" alt="预览" style="width:160px;height:160px;object-fit:contain;border:1px solid #eee;">
        </div>
      </div>
      <template #footer>
        <el-button @click="barcodeVisible = false">取消</el-button>
        <el-button type="primary" :disabled="!barcodeFile" :loading="saving" @click="saveBarcode">确认更换</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessageBox, ElMessage } from 'element-plus';
import axios from 'axios';

export default {
  data() {
    return {
      tableData: [],
      editVisible: false,
      saving: false,
      editForm: { orig_grade: '', orig_class: '', grade: '', class: '', teacher: '' },
      barcodeVisible: false,
      barcodeRow: null,
      barcodeFile: null,
      barcodePreview: '',
    };
  },
  computed: {
    barcodeTitle() {
      if (!this.barcodeRow) return '更换二维码';
      return `更换二维码（${this.barcodeRow.grade}年${this.barcodeRow.class}班）`;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    noop() {},
    async fetchData() {
      try {
        const response = await axios.get('/api/get_data');
        this.tableData = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    openEdit(row) {
      this.editForm = {
        orig_grade: row.grade,
        orig_class: row.class,
        grade: row.grade,
        class: row.class,
        teacher: row.teacher,
      };
      this.editVisible = true;
    },
    saveEdit() {
      if (!this.editForm.grade || !this.editForm.class) {
        ElMessage.error('年级和班级不能为空');
        return;
      }
      this.saving = true;
      axios.post('/api/update_class', this.editForm)
        .then(() => {
          ElMessage.success('修改成功');
          this.editVisible = false;
          this.fetchData();
        })
        .catch((error) => {
          ElMessage.error(error.response?.data?.error || '修改失败');
        })
        .finally(() => {
          this.saving = false;
        });
    },
    confirmDelete(row) {
      ElMessageBox.confirm(
        `确定要删除 ${row.grade}年${row.class}班 吗？`,
        '警告',
        { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
      ).then(() => {
        axios.post('/api/delete_class', { grade: row.grade, class: row.class })
          .then(() => {
            ElMessage.success('删除成功');
            this.fetchData();
          })
          .catch((error) => {
            ElMessage.error(error.response?.data?.error || '删除失败');
          });
      }).catch(() => {});
    },
    openBarcode(row) {
      this.barcodeRow = row;
      this.barcodeFile = null;
      this.barcodePreview = '';
      this.barcodeVisible = true;
    },
    beforeBarcodeUpload(file) {
      this.barcodeFile = file;
      const reader = new FileReader();
      reader.onload = (e) => { this.barcodePreview = e.target.result; };
      reader.readAsDataURL(file);
      return false;
    },
    saveBarcode() {
      if (!this.barcodeFile || !this.barcodeRow) return;
      this.saving = true;
      const formData = new FormData();
      formData.append('file', this.barcodeFile);
      formData.append('grade', this.barcodeRow.grade);
      formData.append('class', this.barcodeRow.class);
      axios.post('/api/update_class_barcode', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(() => {
          ElMessage.success('二维码已更新');
          this.barcodeVisible = false;
          this.fetchData();
        })
        .catch((error) => {
          ElMessage.error(error.response?.data?.error || '更新失败');
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style>
</style>